module.exports = __webpack_public_path__ + "img/top3_species_bu.4410ba5a.png";